import styled from "styled-components";

import { StyledTimelineFilterDialogContent } from "@pages/Patients/Timeline/components/TimelineFilterDialog/TimelineFilterDialog.styled";

import {
  alignItemsCenter,
  flexColumn,
  pseudo,
  rem,
  size,
} from "@styles/Utilities.styled";

// prettier-ignore
export const StyledDocumentationFilterDialogContent = styled(StyledTimelineFilterDialogContent)`
  width: min(95vw, ${rem(750)});

  .physicians-wrapper {
    ${flexColumn}
    gap: 0.6rem;
    align-items: start !important;

    & > div {
      ${alignItemsCenter}
      gap: 0.5rem;
    }
  }

  .ScrollAreaViewport {
    padding: 0.15rem 0.15rem 1.5rem !important;
    max-height: ${rem(380)};
    
    &::before {
      ${pseudo}
      bottom: 0;
      left: 0;
      ${size("100%", rem(40))}
      background: linear-gradient(to top, var(--clr-white), rgb(0,0,0,0));
      pointer-events: none;
    }
  }

  .clear-filter-btn {
    &:disabled {
      color: var(--clr-gray-300);
      cursor: unset;
    }
  }

  .empty-label {
    font-size: ${rem(15)};
    font-weight: 400;
    color: var(--clr-gray-300);
  }
`;
